import BreadcrumbLink from '@/shared/ui/components/BreadcrumbLink';
import type { UIMatch } from 'react-router-dom';

/** Breadcrumb helpers for a route's `handle`, which carries nothing else: `handle: crumb('Readings')`. */

/** Plain-text breadcrumb. */
export const crumb = (label: string) => ({
  crumb: () => <BreadcrumbLink>{label}</BreadcrumbLink>
});

/** Breadcrumb linking to this route, plus `suffix` for a default child. */
export const crumbTo = (label: string, suffix = '') => ({
  crumb: (data: UIMatch) => <BreadcrumbLink to={data.pathname + suffix}>{label}</BreadcrumbLink>
});
